import React, { useEffect, useState } from 'react'

import { useMutation, useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { useParams } from 'react-router-dom';

import {  showDevice, updateDevice } from '../../../../MyApi/sb/device'

import PageHeader from '../../../../Components/UI/PageHeader'
import EditDevice from '../../../../Components/sb/device/deviceUpdate/AddDevice';
import LoadingSpinner from '../../../../Components/UI/spinner';
import NoData from "../../../../Components/UI/nodata"
import ErrorMessage from "../../../../Components/UI/error"



const DevicesUpdate = () => {
  const {id} = useParams()
  const lang = localStorage.getItem("i18nextLng")
  const [selectedLangCode , setSelectedLangCode]= useState(lang)
  const showDeviceQuery = useQuery(["showDevice", id ,selectedLangCode] ,()=>showDevice(id ,selectedLangCode))
  const devices =showDeviceQuery.data?.data || {}
  const [ deviceName ,setDeviceName]= useState("")
  const [mac, setMac] = useState("")
  const [uuid, setUuid] = useState("")
  const [major , setMajor] =useState("")
  const [minor ,setMinor] = useState("")
  const [status ,setStatus]= useState("")
  const [companyId ,setCompanyId] = useState("")
  const [branchId , setBranchId]= useState("")

useEffect(()=>{
  showDeviceQuery.refetch()
},[selectedLangCode])

useEffect(()=>{
  setDeviceName(devices.name)
  setUuid(devices.uuid)
  setMac(devices.mac)
  setMajor(devices.major)
  setMinor(devices.minor)
  setStatus(devices.status)
  setCompanyId(devices.sb_company_id)
  setBranchId(devices.sb_branch_id)
  
  
},[showDeviceQuery.data])

 const mutation = useMutation(["updateDevices" ,id] , (postData)=>updateDevice(postData ,id) ,{
    onSuccess:(data)=>{
        toast.success(`${data.message}`)
  
    },
    onError:(error)=>{
        toast.error(`${error.response.data.message}`)
    }
 })

 const handlePostRequest =()=>{
    mutation.mutate({
        name:deviceName,
        mac,
        uuid,
        major,
        status,      
        sb_company_id:+companyId,
        sb_branch_id:+branchId, 
        minor,

    })
 } 
 const isDisabled= ()=>{
   return false;

 }
 const onSelectChange =(e)=>{
  const {value}=e.target
  setSelectedLangCode(value)
 }
 if(showDeviceQuery.isLoading){
  return <LoadingSpinner/>
 }
 if(showDeviceQuery.error
 ){
  return <ErrorMessage error={showDeviceQuery.error}/>
 }
 if(devices.length===0){
  return <NoData/>
 }

 if(!showDeviceQuery.data){
  return <div>no data avalible</div>
 }
  return ( 

    <div>
        <PageHeader title="Add Device" showSelect onSelectChange={onSelectChange} showBack={true} saveButton={true} isdisbled={isDisabled} handlePostRequest={handlePostRequest} />
        <EditDevice companyId={companyId}   deviceName={deviceName} uuid={uuid} major={major} status={status} minor={minor} branchId={branchId} setCompanyId={setCompanyId} setStatus={setStatus} setMinor={setMinor}  setMajor={setMajor} setUuid={setUuid} setMac={setMac} setBranchId={setBranchId} setDeviceName={setDeviceName} />
    </div>
  )
}

export default DevicesUpdate